const _excluded = ["to", "className", "activeClassname"];function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}function _objectWithoutProperties(e, t) {if (null == e) return {};var o,r,i = _objectWithoutPropertiesLoose(e, t);if (Object.getOwnPropertySymbols) {var n = Object.getOwnPropertySymbols(e);for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);}return i;}function _objectWithoutPropertiesLoose(r, e) {if (null == r) return {};var t = {};for (var n in r) if ({}.hasOwnProperty.call(r, n)) {if (-1 !== e.indexOf(n)) continue;t[n] = r[n];}return t;}import React from 'react';
import { NavLink } from 'react-router';
import { useAtomValue } from 'jotai';
import { localeAtom } from "../V2/atoms";



const I18NLink = (props) => {
  const { to: link, className, activeClassname } = props,rest = _objectWithoutProperties(props, _excluded);
  const locale = useAtomValue(localeAtom);
  const parsedLink = link.startsWith('/') ? link.slice(1) : link;
  const to = locale ? `/${locale}/${parsedLink}` : `/${parsedLink}`;

  return (/*#__PURE__*/
    React.createElement(NavLink, _extends({
      to: to,
      className: ({ isActive }) => `${className || ''} ${isActive ? activeClassname : ''}`
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, rest)
    ));

};

export { I18NLink };